import moment from 'moment';
import { PushNotificationLog } from '../types';
export interface LogDataGridFormat {
  title: string;
  type: string;
  id: string;
  channels: string[];
  app: string;
  timestamp: string;
  message: string;
}

export interface ScheduledDataGridFormat {
  id: string;
  title: string;
  message: string;
  channels: string[];
  target: string;
  app: string;
  pushNotificationImage: string;
  author: string;
  date: string;
}

export const convertFirestoreLogToDatagridFormat = (
  data: PushNotificationLog
): LogDataGridFormat => {
  const { app, id, timestamp } = data;
  const { title, type, description, channels } = data.data;

  return {
    title,
    type,
    id,
    channels,
    app,
    timestamp: moment(timestamp.seconds * 1000).format('YYYY-MM-DD HH:mm:ss'),
    message: description,
  };
};

export const convertFirestoreScheduledNotificationToDatagridFormat = (
  doc: any
): ScheduledDataGridFormat => {
  const data = doc.data();

  const title = data.title;
  const message = data.message;
  const channels = data.channels;
  const target = data.target;
  const app = data.app;
  const pushNotificationImage = data.pushNotificationImage;
  const author = data.author;
  const date = data.date;

  return {
    id: doc.id,
    author,
    title,
    message,
    channels,
    target,
    pushNotificationImage,
    app,
    date: moment(date).format('YYYY-MM-DD HH:mm:ss'),
  };
};
